<template>
<div >
	<b-modal id="modalDamage" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="close" size="lg">
		
		<Loader :show="loading"></Loader>
		
		<div class="fullscreen">
			<div class="head">
				<div class="container">
					<div class="btn icon icon-close invert" @click="close"></div>
					<h1>{{title}}</h1>
				</div>
			</div>
			<div class="content">
				<div class="container">
					<VueSlickCarousel 
						ref="carSwiper" 
						:slidesToShow="1" 
						:slidesToScroll="1"
						:initialSlide="initialSlide"
						:arrows="false" 
						:dots="true"
						class="">
						
						<div v-for="side in sides" :key="side">
							<div 
								class="map" 
								:ref="side" 
								:style="{backgroundImage: `url('${ require('@/assets/img/carsDraws/'+control.car.category.draw+'/'+side+'.png') }')` }" 
								@click="setPoint(side, $event)">
								<div >
									<div class="point animated bounceIn" 
										v-if="form.position.left && form.side==side"
										:style="`left:${form.position.left}%; top:${form.position.top}%`" 
										:class="[form.type.toLowerCase(),{'animated infinite pulse':form.selected}]"
									>
									</div>
								</div>
							</div>
						</div>
					</VueSlickCarousel>
					<div class="invalid-feedback d-block" v-if="validation.hasError('form.position')">Marque la ubicación del daño en el mapa</div>
		
					<b-form-group label="Tipo de daño" class="mt-4" >
						<div class="types">
							
							<!-- <div class="btn-type" @click="selectType('SCRATCH')"  :class="{'selected' : form.type == 'SCRATCH'}" >
								<div class="btn btn-icon-circle" :style="{backgroundImage: `url('${ require('@/assets/img/damage-scratch.png') }')` }" ></div>
								<div class="label">RAYÓN</div>
							</div>
							
							<div class="btn-type" @click="selectType('DENT')"  :class="{'selected' : form.type == 'DENT'}" >
								<div class="btn btn-icon-circle" :style="{backgroundImage: `url('${ require('@/assets/img/damage-dent.png') }')` }" ></div>
								<div class="label">BOLLO</div>
							</div>
							
							<div class="btn-type" @click="selectType('MISSING')"  :class="{'selected' : form.type == 'MISSING'}" >
								<div class="btn btn-icon-circle" :style="{backgroundImage: `url('${ require('@/assets/img/damage-missing.png') }')` }" ></div>
								<div class="label">Faltante</div>
							</div>
							
							<div class="btn-type" @click="selectType('RIVEN')"  :class="{'selected' : form.type == 'RIVEN'}" >
								<div class="btn btn-icon-circle" :style="{backgroundImage: `url('${ require('@/assets/img/damage-riven.png') }')` }" ></div>
								<div class="label">Rajado</div>
							</div>
							
							<div class="btn-type" @click="selectType('OTHER')"  :class="{'selected' : form.type == 'OTHER'}" >
								<div class="btn btn-icon-circle" :style="{backgroundImage: `url('${ require('@/assets/img/damage-other.png') }')` }" ></div>
								<div class="label">Otros</div>
							</div>
							
							<div class="btn-type" @click="selectType('TOTAL')"  :class="{'selected' : form.type == 'TOTAL'}" >
								<div class="btn btn-icon-circle" :style="{backgroundImage: `url('${ require('@/assets/img/damage-total.png') }')` }" ></div>
								<div class="label">DAÑO TOTAL</div>
							</div> -->
							
							<div class="btn-type" v-for="type in types" :key="type.type" 
								@click="selectType(type)" 
								:class="{'selected' : form.type == type.type }" >
								<div class="btn btn-icon-circle" :style="{backgroundImage: `url('${ require(`@/assets/img/damage-${type.type.toLowerCase()}.png`) }')` }" ></div>
								<div class="label">{{type.typeText}}</div>
							</div>


						</div>
					</b-form-group>
					<div class="invalid-feedback d-block" v-if="validation.hasError('form.type')">Seleccione el tipo de daño</div>

					<b-form-group label="Descripción" class="mt-4">
						<b-form-input
							v-model="form.description"
							placeholder="Ingrese una descripción"
							:state="!validation.hasError('form.description')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese una descripción</b-form-invalid-feedback>
					</b-form-group>

					<b-form-group label="Fotos" class="mt-4">
						<UploadMultiple
							v-model="form.images" 
							:placeholder="'SUBIR FOTO'"
							accept="image"
							:invalid="validation.hasError('form.images')" 
							@uploading="showLoader"
						></UploadMultiple>
					</b-form-group>

				</div>
			</div>
			<div class="footer">
				<div class="container">
					<div class="btn btn-block btn-primary" @click="save()">
						<span v-if="form.key">Editar daño</span>
						<span v-else>Crear daño</span>
					</div>
				</div>
			</div>
		</div>

	</b-modal>	
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import UploadMultiple from '@/components/UploadMultiple'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'DamageModal',
	components:{
		Loader,
		VueSlickCarousel,
		UploadMultiple
	},
	mixins:[mixins],
	data () {
		return {
			title: 'Crear daño',
			show: false,
			loading:false,
			saving: false,
			form:{
				key: null,
				description:null,
				position: {},
				type: 'none',
				typeText: null,
				images: [],
				side: 'left'
			},
			sides: ['left','back','right','front','inside','top'],
			types: [
				{
					type:		'SCRATCH',
					typeText: 	'Rayón'
				},
				{
					type:		'DENT',
					typeText: 	'Bollo'
				},
				{
					type:		'MISSING',
					typeText: 	'Faltante'
				},
				{
					type:		'RIVEN',
					typeText: 	'Rajado'
				},
				{
					type:		'TOTAL',
					typeText: 	'Daño total'
				},
				{
					type:		'OTHER',
					typeText: 	'Otro'
				},
			],
			initialSlide: 0
		}
	},
	computed: {
		...mapState(['control']),
	},
	validators: {
		'form.description': function (value) {
			return Validator.value(value).required();
		},
		'form.position': function (value) {
			return Validator.custom( () => {
				if( !value.top || !value.left ){ return true}
				return false
			})
		},
		'form.type': function (value) {
			return Validator.custom( () => {
				return !this.types.some(item => { 
					return item.type == value
				})
			})
		},
		'form.images': function (value) {
			return Validator.custom( () => {
				if(value.length<=0){ return true}
				return false
			})
		},
	},
	methods: {
		...mapMutations(['saveControl']),
		showLoader(data){
			this.loading  = data
		},
		setPoint(side, event) {
			let width = this.$refs[side].clientWidth;
			let height = this.$refs[side].clientHeight;
			let left = (event.offsetX * 100 ) /width
			let top = (event.offsetY * 100 ) /height
			this.form.position = {
				top,
				left
			}
			this.form.side = side
		},
		selectType(type){
			this.form.type = type.type
			this.form.typeText = type.typeText
		},
		open (side) {
			if(side){
				this.form.side = side
			}
			this.showModal()
		},
		update (damage) {
			this.title = 'Editar daño'
			this.form = damage
			this.showModal()
			var slideTo = this.sides.indexOf(this.form.side)
			this.initialSlide = slideTo
		},
		showModal() {
			this.show = true
			this.$bvModal.show('modalDamage')
		},
		close () {
			this.$bvModal.hide('modalDamage')
			this.form = {
				key: null,
				side: null,
				description:null,
				position: {},
				type: 'undefined',
				images: []
			}
			this.$emit('updated')
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				if(!this.form.key){
					this.form.key = this.control.damages.length+1
					this.control.damages.push(this.form)
				}
				this.saveControl(this.control)
				this.saving = false
				this.close()
			}
		}
	}
}


</script>

<style lang="scss" scoped>
	.types{
		width: 100%;
		display: flex;
		justify-content: center;

		.btn-type{
			text-align: center;
			margin:0px 6px;
			
			.btn{
				background-size: contain;
				border: #fff;
				margin: auto;
			}
			.label{
				font-size: .8rem;
				text-transform: uppercase;
			}

			&.selected .btn{
				border: solid 2px #2c8ece;
			}
		}
	}

	@media (max-width: 500px) {
		.btn-type .label{
			font-size: .6rem !important;
		}
		.btn-type .btn-icon-circle{
			width:42px;
			height:42px;
		}
	}
	@media (max-width: 350px) {
		.btn-type .label{
			font-size: .5rem !important;
		}
		.btn-type .btn-icon-circle{
			width:34px;
			height:34px;
		}
	}
</style>